import { BUSCAR_ULTIMOS_HISTORICOS_PASSAGEIRO, LIMPAR_ULTIMOS_HISTORICOS_PASSAGEIRO } from '../../actions/types'

const initialState = undefined


export default function reducerUltimosHistoricosPassageiro (state = [], action = initialState) {
  switch (action.type) {
    case BUSCAR_ULTIMOS_HISTORICOS_PASSAGEIRO: {
      const historicos = action.payload.data;
      if (historicos) {
        return  historicos;
      }
      return []
    }

    case LIMPAR_ULTIMOS_HISTORICOS_PASSAGEIRO:
        return [];
    
    default: {
      return state
    }
  }
}